<div class="select-content-container">
	<div class="select-content-title-container">
		<span class="title-description" translate>issue.widget.selector.feedbackselected</span>

	</div>

	<div class="select-content-subtitle" translate>issue.widget.selector.validateadvice</div>

	<div class="select-content-lists">
	</div>

</div>
